import React from 'react'
import sliderCloseIcon from '../../assets/images/slider-close-icon.svg';
import deletePopupIcon from '../../assets/images/delete-popup-icon.svg'
export default function DeleteVoicemailModal({handleDelete}) {
  return (
    <div className="modal fade" id="deleteVoiceMail" tabIndex="-1" aria-labelledby="deleteVoiceMailLabel" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title" id="deleteVoiceMailLabel">Delete Record</h5>
                <button type="button" className="slider-close-btn" data-bs-dismiss="modal">
                    <img src={sliderCloseIcon} className="img-fluid"/>
                </button>
            </div>
            <div className="modal-body">
                <div className="d-flex justify-content-center">
                    <img src={deletePopupIcon}/>
                </div>
                <div className="mt-4">
                    <p className="text-center">You are about to delete this message conversation. A copy of the conversation can always be found in Audit Logs in your Settings tab. Do you want to delete this conversation from your messages?</p>
                </div>
                <div className="form-check mt-4 d-flex justify-content-center align-items-center">
                    <input className="form-check-input me-2" type="checkbox" value="" id="flexCheckDefault"/>
                    <label className="form-check-label" htmlFor="flexCheckDefault">
                        Don't ask me again for 60 seconds
                    </label>
                </div>
            </div>
            <div className="d-flex justify-content-center mb-5">
                <button className="slider-cancel-btn me-2" data-bs-dismiss="modal">Cancel</button>
                <button className="slider-success-btn" data-bs-dismiss="modal" onClick={handleDelete}>Remove</button>
            </div>
        </div>
    </div>
</div>
  )
}
